"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const ServiceImplBase_1 = require("./ServiceImplBase");
class StoryActivationServiceImpl extends ServiceImplBase_1.ServiceImplBase {
    get serviceName() {
        return "story-activation-service" /* StoryActivation */;
    }
    activateNextStoryPointAsync() {
        const verb = api_internal_contract_js_1.VerbId.ActivateNextStoryPoint;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'activateNextStoryPointAsync',
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    activatePreviousStoryPointAsync() {
        const verb = api_internal_contract_js_1.VerbId.ActivatePreviousStoryPoint;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'activatePreviousStoryPointAsync',
        };
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    activateStoryPointAsync(index) {
        const verb = api_internal_contract_js_1.VerbId.ActivateStoryPoint;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'activateStoryPointAsync',
        };
        parameters[api_internal_contract_js_1.ParameterId.StoryPointIndex] = index;
        return this.execute(verb, parameters).then((response) => {
            return;
        });
    }
    revertStoryPointAsync(index) {
        const verb = api_internal_contract_js_1.VerbId.RevertStoryPoint;
        const parameters = {
            [api_internal_contract_js_1.ParameterId.FunctionName]: 'revertStoryPointAsync',
        };
        parameters[api_internal_contract_js_1.ParameterId.StoryPointIndex] = index;
        return this.execute(verb, parameters).then((response) => {
            return response.result;
        });
    }
}
exports.StoryActivationServiceImpl = StoryActivationServiceImpl;
//# sourceMappingURL=StoryActivationServiceImpl.js.map